function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const closePopup = this.querySelector(".close-popup");
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
    closePopup.addEventListener("click", this.handleClosePopup.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      this.classList.toggle("active");
      const content = document.createElement("div");
      const firstElementChild = this.querySelector("template").content.firstElementChild;
      firstElementChild.classList.add("js-youtube", "w-full", "h-auto", "aspect-video");
      content.appendChild(firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const popupContent = this.querySelector(".popup-content");
      const deferredElement = popupContent.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute("style");
      deferredElement.setAttribute("style", "display: block;");
      window.setTimeout(() => {
        deferredElement.setAttribute("style", formerStyle);
      }, 0);
    }
  }

  handleClosePopup() {
    window.pauseAllMedia();
    this.classList.toggle("active");
    const popupContent = this.querySelector(".popup-content");
    const currentMedia = popupContent.removeChild(popupContent.querySelector("video, model-viewer, iframe"));
    this.removeAttribute("loaded");
  }
}

customElements.define("deferred-media", DeferredMedia);
